import React, { useEffect, useState } from "react";

const KEY = "inz_splash_shown";
const HOLD = 1500;
let seen = false; // survives StrictMode's double mount in dev

const Splash = () => {
  const [state, setState] = useState(() =>
    seen || sessionStorage.getItem(KEY) ? "gone" : "in"
  );

  useEffect(() => {
    if (seen || sessionStorage.getItem(KEY)) return;
    const a = setTimeout(() => setState("out"), HOLD);
    const b = setTimeout(() => {
      seen = true;
      sessionStorage.setItem(KEY, "1");
      setState("gone");
    }, HOLD + 620);
    return () => {
      clearTimeout(a);
      clearTimeout(b);
    };
  }, []);

  if (state === "gone") return null;

  return (
    <div
      className={`splash ${state === "out" ? "is-out" : ""}`}
      aria-hidden="true"
      data-testid="splash-screen"
    >
      <div className="splash-glow" />
      <div className="splash-mark">
        <svg viewBox="0 0 200 200" className="splash-sun">
          <defs>
            <radialGradient id="sp-core" cx="42%" cy="36%" r="72%">
              <stop offset="0%" stopColor="#FFF6D2" />
              <stop offset="34%" stopColor="#FFD972" />
              <stop offset="72%" stopColor="#F5A623" />
              <stop offset="100%" stopColor="#FF7A26" />
            </radialGradient>
          </defs>
          <g
            className="splash-rays"
            stroke="#FFC94A"
            strokeWidth="11"
            strokeLinecap="round"
          >
            <line x1="100" y1="12" x2="100" y2="42" />
            <line x1="100" y1="158" x2="100" y2="188" />
            <line x1="12" y1="100" x2="42" y2="100" />
            <line x1="158" y1="100" x2="188" y2="100" />
            <line x1="39" y1="39" x2="60" y2="60" />
            <line x1="140" y1="140" x2="161" y2="161" />
            <line x1="161" y1="39" x2="140" y2="60" />
            <line x1="60" y1="140" x2="39" y2="161" />
          </g>
          <circle
            className="splash-core"
            cx="100"
            cy="100"
            r="46"
            fill="url(#sp-core)"
          />
          <circle
            className="splash-core"
            cx="100"
            cy="100"
            r="46"
            fill="none"
            stroke="#fff"
            strokeOpacity="0.55"
            strokeWidth="2.5"
          />
        </svg>
        <p className="splash-word">InZoRAH</p>
        <p className="splash-tag">see what&rsquo;s really in it</p>
      </div>
    </div>
  );
};

export default Splash;
